<template>
    <div class="card-container">
        <card></card>
    </div>
</template>

<style lang="scss" scoped>
.card-container {
    padding-top: 75px;
}
</style>

<script>
    import Card from '@/components/card/Card.vue';

    export default {
        components: {
            Card
        }
    }
</script>